import { ElementFactory } from "./ElementFactory";
/**
 * Custom Element Factory
 */
export class CustomElementFactory extends ElementFactory {
    /**
     * Creates element
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    createElement(htmlElement, bindData, context) {
        return this.doCreateElement(htmlElement, bindData, context);
    }
}
//# sourceMappingURL=CustomElementFactory.js.map